const ContactInformation = {
  name: 'contactInformation',
  title: 'CONTACT INFORMATION',
  titleVariant: 'subsection',
  container: 'default',
  fields: [
    {
      variant: 'phone',
      name: 'phoneNumber',
      label: 'Phone Number',
      placeholder: '(000) 000-0000',
      rules: {
        required: true,
      },
      GridProps: { xs: 12, sm: 3 },
    },
    {
      variant: 'email',
      name: 'emailAddress',
      label: 'Email',
      rules: {
        required: true,
      },
      GridProps: { xs: 12, sm: 4 },
    },
  ],
};

export default ContactInformation;
